import $ from 'jquery';
import 'slick-carousel';

function FrontCtrl(target) {
	this.$target = $(target);
}

FrontCtrl.prototype.init = function () {
	var self = this;

	this.$target.slick({
		infinite: true,
		slidesToShow: 1,
		slidesToScroll: 1,
		speed: 700,
		// adaptiveHeight: true,
		autoplay: true,
		autoplaySpeed: 7000,
		dots: false,
		fade: true,
		cssEase: 'linear',
		// asNavFor: '.slider__nav',
		responsive: [
			{
				breakpoint: 768,
				settings: {
					dots: false
				}
			},
			{
				breakpoint: 480,
				settings: {
					arrows: false,
					dots: false,
					speed: 500,
					autoplay: false
				}
			}
		]
	})
}

export default FrontCtrl;
